/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */

import React, { useState, useEffect, useRef } from 'react';
import ActionToolbar from '../../../common/toolbar/action-toolbar';
import { LoadPanel } from "devextreme-react";
import { browserHistory } from 'react-router';
import Config from '../../../../config/index';
import { Button, Accordion, AccordionSummary, AccordionDetails, Attachment } from 'diginet-core-ui/components';
import TabGeneral from '../W06F0009/W06F0009TabGeneral';
import TabInventory from '../W06F0009/W06F0009TabInventory';
import { makeStyles } from '@material-ui/core/styles';
import * as W06F0010Actions from '../../../../redux/W0X/W06F0010/W06F0010_actions';
import * as W06F0009Actions from '../../../../redux/W0X/W06F0009/W06F0009_actions';
import * as generalActions from '../../../../redux/general/general_actions';
import { useDispatch } from 'react-redux';
import ViewHistory from '../../../common/view-history/ViewHistory';

const useStyles = makeStyles((theme) => ({
    textInfo: {
        // color: theme.palette.primary.main,
        // fontSize: 16,
        // fontWeight: 600
    },
    TabContainer: {
        '& .DGN-UI-Accordion': {
            marginTop: 15
        }
    },
    subTitle: {
        color: '#7F828E'
    }
}));

const W05F0010 = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(null);
    const [decimalQuantity, SetDecimalQuantity] = useState(null);
    const ExchangeRate = useRef(1);
    const [dataHistory, setDataHistory] = useState({ rows: [], total: 0 });
    const [filterHistory, setFilterHistory] = useState({ skip: 0, limit: 10 });

    const [permission, setPermission] = useState(0);

    const getInfo = (flag) => {
        const { location } = props;
        if (location && location.state) {
            return {
                ContractID: location.state.ContractID,
                ContractNo: location.state.ContractNo,
                SubContractID: location.state.SubContractID,
                IsApprove: location.state.IsApprove,
                mode: location.state.mode,
            }
        } else {
            if (flag) {
                browserHistory.push(Config.getRootPath() + "W06F0008");
                return null;
            }
            return false;
        }
    };

    const loadPermission = (formID) => {
        dispatch(generalActions.getPermission("W06F0008", (isPer) => {
            if (isPer) {
                setPermission(isPer);
            }
        }))
    };

    useEffect(() => {
        if (!getInfo(true)) return;
        loadPermission();
        /* eslint-disable */
    }, [])

    useEffect(() => {
        if (permission > 0) {
            const { mode } = getInfo();
            loadForm(mode);
        }
        /* eslint-disable */
    }, [permission])

    useEffect(() => {
        if (permission > 0) {
            getHistory();
        }
        /* eslint-disable */
    }, [filterHistory, permission])

    const loadForm = (_mode) => {
        const params = {
            Language: Config.language || 84,
            ContractID: ContractID,
            SubContractID: SubContractID
        };
        setLoading(true);
        dispatch(W06F0010Actions.loadForm(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("danger", message);
                setLoading(false);
                return false;
            }
            setFormData(data);
            ExchangeRate.current = data.master?.ExchangeRate;
            getDecimalQuantity(data.master?.CurrencyID);
        }));
    }

    const getHistory = () => {
        const params = {
            keyword: "",
            condition: JSON.stringify({ codeID: SubContractID }),
            limit: filterHistory.limit,
            skip: filterHistory.skip,
            sort: ""
        };
        dispatch(generalActions.loadHistory(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("danger", message);
                setLoading(false);
                return false;
            }
            setDataHistory(data);
        }));
    }

    const getDecimalQuantity = (CurrencyID) => {
        dispatch(W06F0009Actions.getDecimalQuantity({ CurrencyID }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("danger", message);
                setLoading(false);
                return false;
            }
            setLoading(false);
            SetDecimalQuantity(data);
        }));
    }

    const numberFormat = (number, limitNumber = 0) => {
        const formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: limitNumber,
            maximumFractionDigits: limitNumber,
        });
        const _number = formatter.format(String(number));
        return !_number || _number === "NaN" ? 0 : _number;
    };

    const countDecimals = (value) => {
        if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    }

    const cellRenderNumber = (e, decimal) => {
        if (Config.isEmpty(e.displayValue) && e.displayValue !== 0) return null;
        return numberFormat(e.displayValue, decimal ?? countDecimals(e.displayValue));
    }

    const onChangeHistoryPage = (page) => {
        setFilterHistory({ ...filterHistory, skip: page * filterHistory.limit });
    };

    const onChangeHistoryPerPage = (perPage) => {
        setFilterHistory({ limit: perPage, skip: 0 });
    };

    const onEdit = () => {
        browserHistory.push({
            pathname: Config.getRootPath() + 'W06F0009',
            state: {
                ContractID: ContractID,
                SubContractID: SubContractID,
                ContractNo: ContractNo,
                mode: 'edit'
            }
        });
    }

    if (!getInfo() || permission <= 0) return null;
    const { ContractNo, ContractID, SubContractID, mode, IsApprove } = getInfo();
    return (
        <div className={classes.TabContainer}>
            <ActionToolbar allwaysTop title={Config.lang("Chi_tiet_phu_luc_hop_dong_mua")} onBack={() => browserHistory.push(Config.getRootPath() + "W06F0008")}>
                <div className="display_row align-center align-between full_w">
                    <div className="display_row align-center">
                        {!Number(IsApprove) && <Button viewType="outlined" startIcon="edit" color='primary' label={Config.lang("Sua")} onClick={onEdit} />}
                        <Button viewType="outlined" startIcon="export" color='primary' label={Config.lang("Xuat_du_lieu")} />
                    </div>
                    <span className={classes.subTitle}>{Config.lang('Phu_luc_hop_dong')}: {ContractNo}</span>
                </div>
            </ActionToolbar>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ my: 'center', of: "root" }}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
            />
            <TabGeneral
                classes={classes} formData={formData?.master}
                decimalQuantity={decimalQuantity} mode={mode}
                attachments={formData?.attachments ?? []}
                ContractID={ContractID}
            />
            <Accordion boxShadow>
                <AccordionSummary>
                    <div className={classes.textInfo}>{Config.lang('Hang_hoa')}</div>
                </AccordionSummary>
                <AccordionDetails >
                    <TabInventory
                        formData={formData?.commodity} decimalQuantity={decimalQuantity}
                        ExchangeRate={ExchangeRate.current} numberFormat={numberFormat}
                        cellRenderNumber={cellRenderNumber} mode={mode} TransTypeID={formData?.master?.TransTypeID}
                        CurrencyID={formData?.master?.CurrencyID}
                    />
                </AccordionDetails>
            </Accordion>
            <Accordion boxShadow>
                <AccordionSummary>
                    <div className={classes.textInfo}>{Config.lang('Lich_su')}</div>
                </AccordionSummary>
                <AccordionDetails style={{ marginLeft: 20 }}>
                    <ViewHistory
                        dataHistory={dataHistory.rows}
                        totalItems={dataHistory.total}
                        loading={false}
                        skip={filterHistory.skip}
                        limit={filterHistory.limit}
                        onChangePage={onChangeHistoryPage}
                        onChangePerPage={onChangeHistoryPerPage}
                    />
                </AccordionDetails>
            </Accordion>
            {formData?.attachments && formData?.attachments.length > 0 &&
                <Attachment
                    className="mgt10"
                    data={formData?.attachments ?? []}
                    readOnly
                />
            }
        </div>
    );
};

export default W05F0010;
